import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
let screenMobile = window.matchMedia("(max-width: 576px)");

class Section3DFeature extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header");
    this.section = this.querySelector("[data-section]");
    this.sectionContainer = this.querySelector("[data-sectionContainer]");
    this.video = this.querySelector("[data-video]");
    this.animate = this.querySelector(".animate");
    this.nextSection = this.section.parentNode.parentNode.nextSibling;

    this.initFunction();
  }

  initFunction() {
    this.headerHeight = this.header.offsetHeight || 100;
    if (this.animate) {
      this.scrubVideo();
    } else {
      this.playVideo();
    }
  }

  playVideo() {
    ScrollTrigger.create({
      trigger: this.video,
      start: "top 20%",
      end: "bottom center",
      onEnter: () => {
        this.video.play();
      },
    });
  }

  scrubVideo() {
    // ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -movflags faststart -vcodec libx264 -crf 23 -g 1 -pix_fmt yuv420p output.mp4
    // ffmpeg -i ~/Downloads/Toshiba\ video/original.mov -vf scale=960:-1 -movflags faststart -vcodec libx264 -crf 20 -g 1 -pix_fmt yuv420p output_960.mp4

    let src = this.video.currentSrc || this.video.src;

    function once(el, event, fn, opts) {
      var onceFn = function (e) {
        el.removeEventListener(event, onceFn);
        fn.apply(this, arguments);
      };
      el.addEventListener(event, onceFn, opts);
      return onceFn;
    }

    once(document.documentElement, "touchstart", function (e) {
      this.video.play();
      this.video.pause();
    });
    let navigation = document.querySelector(
      ".product-landing-navigation"
    )?.offsetHeight;
    let top = screenMobile.matches ? `top ${navigation}px` : "top top";
    if (this.section.offsetHeight > window.outerHeight) {
      top = `top ${-(this.section.offsetHeight - window.outerHeight) / 2}px`;
    }
    let tl = gsap.timeline({
      defaults: { duration: 1 },
      scrollTrigger: {
        trigger: this.section,
        start: top,
        end: "+=300%",
        scrub: true,
        pin: true,
      },
    });

    const onVideoMetadataAvailable = () => {
      tl.fromTo(
        this.video,
        {
          currentTime: 0,
        },
        {
          currentTime: this.video.duration || 1,
        }
      );
    };

    if (this.video.videoHeight > 0) {
      onVideoMetadataAvailable();
    } else {
      once(this.video, "loadedmetadata", onVideoMetadataAvailable);
    }

    setTimeout(function () {
      if (window["fetch"] && this.video) {
        fetch(src)
          .then((response) => response.blob())
          .then((response) => {
            var blobURL = URL.createObjectURL(response);
            var t = this.video?.currentTime;
            once(document.documentElement, "touchstart", function (e) {
              this.video.play();
              this.video.pause();
            });

            this.video.setAttribute("src", blobURL);
            this.video.currentTime = t + 0.01;
          });
      }
    }, 1000);

    /* ---------------------------------- */
  }
}

if (!customElements.get("section-3d-feature")) {
  customElements.define("section-3d-feature", Section3DFeature);
}
